module.exports = __webpack_public_path__ + "img/database-link.fb987f55.svg";